import { getRequest } from '../services/requestHandler';
import { LoftDigit } from '../models';

//6 for testing
export const getLoftDigits = async (headTypeId = null) => {
  const url = headTypeId ? `loft/getLoftDigits?headTypeId=${headTypeId}` : 'loft/getLoftDigits';
  const response = await getRequest<LoftDigit>('GetLoftDigits', url);
  return response;
};
